import styled from "@emotion/styled";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
import "@mondaydotcomorg/monday-ui-components/dist/TilesList.css";
export const StyledCategoryIdToTileMapping = styled.div`
  .tile-items--container {
    row-gap: 20px;
    
    .tile-item--container {
      margin: 6px;
    }

    .tile-item--wrapper {
      display: flex;
      align-items: center;

      .tile-item--background {
        width: 100px;
        height: 100px;
        text-align: center;

        svg {
          width: calc(100% - 15px);
          height: calc(100% - 15px);
        }

        &:has(.ai-create-main-icon) {
          border: 1px dashed #6161ff;
          box-sizing: border-box;
          position: relative;

          .ai-create-main-icon {
            width: 54px;
            height: 54px;
          }

          .ai-create-icon-wrapper {
            position: absolute;
            top: 8px;
            right: 8px;
            width: 24px;
            height: 24px;
            background: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.08);

            svg {
              width: 14px;
              height: 14px;

              path {
                stroke: #6161ff;
                stroke-width: 2;
              }
            }
          }
        }
      }

      .tile-item--label {
        font-size: 16px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .tiles-list--wrapper {
      text-align: center;

      .tile-items--container {
        margin-top: 16px;
        margin-right: -12px;
        justify-content: center;
        row-gap: 0px;

        .tile-item--container {
          margin: 6px 12px;

          .tile-item--wrapper {
            margin-top: 8px;
            width: calc(100vw / 2 - 40px);

            .tile-item--background {
              width: 100%;
              height: 52px;

              svg {
                height: 32px;
                width: auto;
              }

              &:has(.ai-create-main-icon) {
                .ai-create-icon-wrapper {
                  svg {
                    padding: 4px;
                  }
                }
              }
            }

            .tile-item--label {
              margin-top: 8px;
              font-size: 0.6875rem;
            }
          }
        }
      }
    }
  }
`;
